// IMPORTANT: Note that with Redux, state should NEVER be changed.
import objectAssign from 'object-assign';
import { organisationInitialState } from '../store/initialState';
import { clone } from './helper';
import { sortOrganisationalUnit, sortManageRoleNaming } from '../businessLogic/sorting';
import { removeDuplicateArray } from '../businessLogic/helperHooks';

import {
  UPDATED_CURRENT_FILLED_ORG_STEP,
  UPDATED_CURRENT_CREATE_ORG_STEP,
  GET_ORGANISATIONS,
  ERROR_GET_ORGANISATION,
  UPDATE_FETCHING_ORGANISATION,
  GOT_ORGANISATIONS,
  ERROR_GETTING_ORGANISATIONS,
  UPDATED_ORG_UNIT_FORM,
  GET_ORGANISATION,
  UPDATE_ORGANISATIONAL_UNIT_PERMISSION,
  UPDATE_ORG_SELECTED_USER_FOR_MANAGEMENT,
  UPDATE_ROLES_FOR_SELECTED_USER_IN_ORG_MANAGE_USERS_PAGE,
  GOT_ORGANISATION,
  GOT_SHORT_URLS,
  SELECTED_SHORT_URL,
  SELECT_ORG_UNIT,
  SELECT_ORG_UNIT_ID,
  SHOW_CREATE_ORG_MODAL,
  HIDE_CREATE_ORG_MODAL,
  RESET_ORG_UNIT_FORM,
  GET_ORGANISATIONS_WITH_PERMISSION,
  GOT_ORGANISATIONS_WITH_CREATE_PERMISSION,
  GET_ORG_UNIT_WEBSITE_DETAILS,
  GOT_ORG_UNIT_WEBSITE_DETAILS,
  UPDATE_ORG_WEBSITE_BUTTON_DETAILS,
  UPDATED_ORG_WEBSITE_BUTTON_DETAILS,
  DELETE_ORG_UNIT,
  DELETED_ORG_UNIT,
  UPDATE_ORG_UNIT_SEARCH,
  UPDATE_ORGANISATIONAL_UNIT_MEMBER_SEARCH,
  ADD_USERS_FORM,
  //Manage roles for waiting areas
  GOT_AVAILABLE_ROLES_FOR_ORGANISATIONAL_UNIT,
  ORG_UNIT_TAGS,
  GENERAL_INFO_FORM,
  CLEAR_ORG_UNIT_GENERAL_INFO_FORM,
  ORG_UNIT_SUPPORT_CONTACT,
  ///Organisational unit logo
  GET_ORGANISATIONAL_UNIT_LOGO_IMAGE,
  GOT_ORGANISATIONAL_UNIT_LOGO_IMAGE,
  UPDATE_ORGANISATIONAL_UNIT_LOGO_IMAGE_FORM,
  UPDATE_ORGANISATIONAL_UNIT_LOGO_IMAGE,

  //Before calls
  GOT_ORGANISATIONAL_UNIT_BEFORE_CALLS_FOR_WA,
  MODIFIED_ORGANISATIONAL_UNIT_BEFORE_CALLS_FOR_WA,
  // Entity admin
  GOT_ALL_ENTITIES_PAGINATION,
  RESET_ENTITY_SEARCH_FROM,
  UPDATE_ENTITY_SEARCH_FROM,
  UPDATE_CURRENT_ACTIVE_PAGENO_FOR_ENTITY_PAGE,
  IS_ON_ENTITY_LISTING_PAGE,
  GOT_ALL_WA_ENTITIES_PAGINATION,
  GOT_ALL_MR_ENTITIES_PAGINATION,
  IS_FETCHING_WA_ENTITIES,
  GOT_WAITING_AREA_BY_SEARCH_TERM,
  DELETED_WAITING_AREA_FROM_ORG,
  GOT_MEETING_ROOM_BY_ID_AND_SEARCH_TERM,
  DELETED_MEETING_ROOM_FROM_ORG,
  UPDATE_RHS_TOTAL_COUNT,
  UPDATE_FILTER_VALUE,
  GOT_SHARE_LINK_MESSAGE_FOR_WA,
  GOT_OURECORDING_SETTING_FEATURE,

  //OU GC SETTINGS
  GOT_OU_GC_SETTINGS,
  MODIFIED_GC_OU_SETTING_FORM,
  REMOVE_DELETED_ORGANIZATION,
  SET_MEETING_ROOMS_DELETION_STATUS,
  SET_WAITING_AREAS_DELETION_STATUS,
  SET_ORGANIZATION_DELETION_STATUS,
} from '../actions/organisation.js';
import { GOT_ORGANISATIONAL_UNIT_USERS } from '../actions/user.js';

const reducer = (state = organisationInitialState, action, cleanOrgUnitForm = state.cleanOrgUnitForm) => {
  switch (action.type) {
    case UPDATE_ORG_UNIT_SEARCH:
      return objectAssign({}, state, { currentOrgUnitFilter: action.data });

    case UPDATE_ORGANISATIONAL_UNIT_MEMBER_SEARCH:
      return objectAssign({}, state, { currentOrganisationalUnitMemberFilter: action.data });
    case RESET_ORG_UNIT_FORM:
      return objectAssign({}, state, { orgUnitForm: cleanOrgUnitForm });
    case UPDATED_CURRENT_FILLED_ORG_STEP:
      return objectAssign({}, state, { currentFilledCreateOrgSteps: action.data });
    case UPDATED_CURRENT_CREATE_ORG_STEP:
      return objectAssign({}, state, { currentCreateOrgStep: action.data });

    case SHOW_CREATE_ORG_MODAL:
      return objectAssign({}, state, { showCenterPanelCreate: true });

    case HIDE_CREATE_ORG_MODAL:
      return objectAssign({}, state, { showCenterPanelCreate: false });

    case GET_ORGANISATIONS:
      return objectAssign({}, state, { fetchingOrganisations: true });

    case GET_ORGANISATIONS_WITH_PERMISSION:
      return objectAssign({}, state, { fetchingOrganisationsWithPermission: true });

    case GOT_ORGANISATIONS_WITH_CREATE_PERMISSION:
      return objectAssign({}, state, {
        groupOrganisations: action.data,
        fetchingOrganisationsWithPermission: false,
      });

    case GOT_ORGANISATIONAL_UNIT_USERS: {
      if (state.selectedOrgUnitId === action.data.organisationNetworkId) {
        return objectAssign({}, state, {
          selectedOrgUsersEmail: action.data.organisationUsers.emailUsers,
        });
      } else {
        return state;
      }
    }
    case UPDATE_ORGANISATIONAL_UNIT_PERMISSION: {
      let organisations = clone(state.organisations);

      action.data.map((x) => {
        let org = organisations.find((org) => org.id == x.id);
        if (org) {
          org.permissions = x.permissions;
        }
      });
      return objectAssign({}, state, { organisations: organisations });
    }

    case UPDATED_ORG_UNIT_FORM:
      return objectAssign({}, state, { orgUnitForm: action.data });

    case GOT_ORGANISATIONS:
      return objectAssign({}, state, {
        organisations: sortOrganisationalUnit(action.data),
        fetchingOrganisations: false,
        organisationsInitiallyLoaded: true,
      });

    case GET_ORGANISATION:
      return objectAssign({}, state, {
        fetchingOrganisation: true,
      });
    case ERROR_GET_ORGANISATION:
      return objectAssign({}, state, {
        fetchingOrganisation: false,
      });

    case UPDATE_FETCHING_ORGANISATION:
      return objectAssign({}, state, {
        fetchingOrganisation: action.data,
      });

    case GOT_ORGANISATION: {
      var copyOrgs = clone(state.organisations);
      let selectedOrg = clone(state.selectedOrgUnit);
      let isOnEntityListingPage = state.isOnEntityListingPage;
      let searchedEntityType = state.entitySearchForm.searchedEntityType;
      let orgUpdated = action.data;
      let orgFoundIndex = copyOrgs.findIndex((x) => x.id == action.data.id);
      if (orgFoundIndex > -1) {
        if (!!action.data.isInSearchCriteria || !isOnEntityListingPage) {
          // If it meets search term and exists in current set, replace the record
          let orgNewDetail = {
            ...orgUpdated,
          };
          copyOrgs[orgFoundIndex] = Object.assign({}, copyOrgs[orgFoundIndex], orgNewDetail);
        } else if (!action.data.isInSearchCriteria && isOnEntityListingPage && searchedEntityType === 'org') {
          // If it does not meet the search term and on Administrators page, remove this org
          copyOrgs.splice(orgFoundIndex, 1);
        }
      } else {
        if ((!!action.data.isInSearchCriteria && searchedEntityType === 'org') || !isOnEntityListingPage) {
          // If it meets the search criteria then add it
          // Only when filter is on org will add this new org
          // Filter on WA, new org is added it won't update
          copyOrgs.push(Object.assign({}, state.cleanOrgUnitForm, orgUpdated));
        }
      }

      if (selectedOrg && selectedOrg.id == action.data.id) {
        selectedOrg = { ...selectedOrg, ...action.data };
      }

      var sortedOrganisations = sortOrganisationalUnit(copyOrgs);
      return objectAssign({}, state, {
        organisations: sortedOrganisations,
        fetchingOrganisation: false,
        selectedOrgUnit: selectedOrg,
      });
    }

    case GOT_SHORT_URLS:
      const shortUrlsArray = [];
      for (let i = 0; i < action.data.length; i++) {
        shortUrlsArray.push({ text: action.data[i].url, value: i });
      }
      return objectAssign({}, state, {
        shortUrls: shortUrlsArray,
      });
    case SELECTED_SHORT_URL:
      return objectAssign({}, state, {
        selectedShortUrl: action.data,
      });
    case SELECT_ORG_UNIT_ID:
      return objectAssign({}, state, {
        fetchingOrgUnit: true,
        selectedOrgUnitId: action.data,
      });
    case SELECT_ORG_UNIT:
      return objectAssign({}, state, {
        selectedOrgUnit: action.data,
      });

    case GET_ORG_UNIT_WEBSITE_DETAILS:
      var copy = clone(state);
      copy.orgUnitForm.fetchingWebSiteButtonDetails = true;
      return objectAssign({}, state, { orgUnitForm: copy.orgUnitForm });

    case GOT_ORG_UNIT_WEBSITE_DETAILS:
      var copy2 = clone(state);
      var toBeUpdated = copy2.orgUnitForm;
      toBeUpdated.websiteButtonDetails = action.data;
      toBeUpdated.fetchingWebSiteButtonDetails = false;
      return objectAssign({}, state, { orgUnitForm: toBeUpdated });

    case DELETE_ORG_UNIT:
      return objectAssign({}, state, { deletingOrg: true });

    case DELETED_ORG_UNIT: {
      return objectAssign({}, state, {
        organisations: state.organisations.filter((p) => p.networkId !== action.data),
        deletingOrg: false,
      });
    }

    //OU_GC_SETTINGS for chat and fullname control
    case GOT_OU_GC_SETTINGS:
      return objectAssign({}, state, {
        ouGcSettings: action.data,
      });
    case MODIFIED_GC_OU_SETTING_FORM:
      return objectAssign({}, state, { gcWaitngAreaOUSettingForm: action.data });

    case UPDATE_ORG_WEBSITE_BUTTON_DETAILS:
      var copy2 = clone(state);
      var toBeUpdated = copy2.orgUnitForm;
      toBeUpdated.fetchingWebSiteButtonDetails = true;
      return objectAssign({}, state, { orgUnitForm: toBeUpdated });

    case UPDATED_ORG_WEBSITE_BUTTON_DETAILS:
      var copy2 = clone(state);
      var toBeUpdated = copy2.orgUnitForm;
      // toBeUpdated.websiteButtonDetails = action.data;
      toBeUpdated.fetchingWebSiteButtonDetails = false;
      return objectAssign({}, state, { orgUnitForm: toBeUpdated });

    //////////////////////////////////////////////Organisational Unit Logo  Image////////////////////////////
    case GET_ORGANISATIONAL_UNIT_LOGO_IMAGE:
      return objectAssign({}, state, { organisationalUnitLogoImageForm: {} });
    case GOT_ORGANISATIONAL_UNIT_LOGO_IMAGE:
      return objectAssign({}, state, { organisationalUnitLogoImageForm: action.data });
    case UPDATE_ORGANISATIONAL_UNIT_LOGO_IMAGE_FORM:
      return objectAssign({}, state, {
        organisationalUnitLogoImageForm: action.data,
      });

    case UPDATE_ORGANISATIONAL_UNIT_LOGO_IMAGE:
      let organisationalUnit = clone(state.organisationalUnitLogoImageForm);
      organisationalUnit.isSaving = true;
      return objectAssign({}, state, { organisationalUnitImageForm: organisationalUnit });
    /////////////////////////////////////////////End Organisatioanl Unit Logo Image///////////////////////

    /////////////////////////////////////////////OU_GC_SETTINGS for chat and fullname control///////////////////////
    //OU_GC_SETTINGS for chat and fullname control
    case GOT_OU_GC_SETTINGS:
      return objectAssign({}, state, {
        ouGcSettings: action.data,
      });
    case MODIFIED_GC_OU_SETTING_FORM:
      return objectAssign({}, state, { gcWaitngAreaOUSettingForm: action.data });
    /////////////////////////////////////////////END: OU_GC_SETTINGS for chat and fullname control///////////////////////

    //--------------------- ORG UNIT TAGS ----------------------------------

    case ORG_UNIT_TAGS.GOT_TAGS:
      let copyOrgUnitsWithTags = clone(state.organisations);
      let foundOrgUnitWithTags = copyOrgUnitsWithTags.find((ou) => ou.networkId == action.data.networkId);
      if (foundOrgUnitWithTags) foundOrgUnitWithTags.tags = action.data.tags;

      return objectAssign({}, state, { organisations: copyOrgUnitsWithTags });
    case ORG_UNIT_TAGS.UPDATE_SEARCH_TERM:
      return objectAssign({}, state, { currentOrgUnitTagFilter: action.data });
    case ORG_UNIT_TAGS.GOT_AVAILABLE_TAGS_BY_NETWORKID:
      return objectAssign({}, state, { availableTagsByNetworkId: action.data });
    case ORG_UNIT_TAGS.UPDATE_SELECTED_TAG_FOR_MANAGEMENT:
      let selectedTagObject = clone(state).selectedTagObject;
      let updatedSelectedTagObject = objectAssign({}, selectedTagObject, action.data);
      return objectAssign({}, state, { selectedTagObject: updatedSelectedTagObject });
    case ORG_UNIT_TAGS.UPDATE_ASSIGN_TAG_VALUES_FORM:
      let assignTagValuesForm = clone(state).assignTagValuesForm;
      let updatedAssignTagValuesForm = objectAssign({}, assignTagValuesForm, action.data);
      return objectAssign({}, state, { assignTagValuesForm: updatedAssignTagValuesForm });
    case ORG_UNIT_TAGS.CLEAR_TEMP_ASSIGN_TAGS_OBJECT:
      return objectAssign({}, state, {
        selectedTagObject: organisationInitialState.selectedTagObject,
        assignTagValuesForm: organisationInitialState.assignTagValuesForm,
      });
    //--------------------- END WAITING AREA TAGS  -----------------------------
    // Manage available roles for Organisation
    case GOT_AVAILABLE_ROLES_FOR_ORGANISATIONAL_UNIT:
      var organisations = clone(state.organisations);
      if (action.data) {
        let availableRoles = sortManageRoleNaming(action.data);
        if (organisations.length > 0)
          var org = organisations.find((selectedWA) => selectedWA.networkId == state.selectedOrgUnitId);
        if (org) {
          org.availableRoles = availableRoles;
        }
      }
      return objectAssign({}, state, { organisations: organisations });

    case UPDATE_ORG_SELECTED_USER_FOR_MANAGEMENT:
      var manageUsersPage = {
        selectedUserId: action.data,
      };
      return Object.assign({}, state, {
        manageUsersPage: manageUsersPage,
      });
    case UPDATE_ROLES_FOR_SELECTED_USER_IN_ORG_MANAGE_USERS_PAGE:
      var manageUsersPage = clone(state.manageUsersPage);
      manageUsersPage.rolesForSelectedUser = action.data;
      return Object.assign({}, state, {
        manageUsersPage: manageUsersPage,
      });
    case ADD_USERS_FORM.SELECT_ROLE: {
      const updatedAddUsersForm = objectAssign({}, state.addUsersForm, {
        selectedRoles: state.addUsersForm.selectedRoles.concat(action.data),
      });
      return objectAssign({}, state, { addUsersForm: updatedAddUsersForm });
    }
    case ADD_USERS_FORM.UNSELECT_ROLE: {
      const updatedAddUsersForm = objectAssign({}, state.addUsersForm, {
        selectedRoles: state.addUsersForm.selectedRoles.filter((item) => item != action.data),
      });
      return objectAssign({}, state, { addUsersForm: updatedAddUsersForm });
    }
    case ADD_USERS_FORM.UPDATE_MESSAGE: {
      const updatedAddUsersForm = objectAssign({}, state.addUsersForm, { message: action.data });
      return objectAssign({}, state, { addUsersForm: updatedAddUsersForm });
    }
    case ADD_USERS_FORM.CLEAR_FORM: {
      // reset the form state
      return objectAssign({}, state, { addUsersForm: organisationInitialState.addUsersForm });
    }
    case ADD_USERS_FORM.ADDING_USERS_TO_ORGANISATIONAL_UNIT: {
      const updatedAddUsersForm = objectAssign({}, state.addUsersForm);
      return objectAssign({}, state, { addUsersForm: updatedAddUsersForm });
    }

    // General Information
    case GENERAL_INFO_FORM.GOT_GENERAL_INFO_FORM:
      var organisations = clone(state.organisations);
      var foundIndex = organisations.findIndex((selectedOrg) => selectedOrg.networkId == action.data.id);
      if (foundIndex > -1) {
        organisations[foundIndex].orgUnitGeneralInfoForm = action.data.orgUnitGeneralInfoForm;
      }
      return objectAssign({}, state, {
        organisations: organisations,
        updatedOrgUnitGeneralInfoForm: action.data.orgUnitGeneralInfoForm,
      });
    case GENERAL_INFO_FORM.UPDATE_EDIT_GENERAL_INFO_FORM:
      var orgUnitGeneralInfoForm = objectAssign({}, action.data, {
        orgNameDuplicate: false,
      });
      return objectAssign({}, state, { updatedOrgUnitGeneralInfoForm: orgUnitGeneralInfoForm });
    case GENERAL_INFO_FORM.ORG_NAME_DUPLICATE:
      var orgUnitGeneralInfoForm = objectAssign({}, state.updatedOrgUnitGeneralInfoForm, {
        orgNameDuplicate: action.data,
      });
      return objectAssign({}, state, { updatedOrgUnitGeneralInfoForm: orgUnitGeneralInfoForm });
    case GENERAL_INFO_FORM.SET_ORG_UNIT_GENERAL_INFO_FORM_TRIM:
      let orgUnitGeneralInfoFormTrim = clone(state.updatedOrgUnitGeneralInfoForm);
      orgUnitGeneralInfoFormTrim.name = orgUnitGeneralInfoFormTrim.name ? orgUnitGeneralInfoFormTrim.name.trim() : '';
      orgUnitGeneralInfoFormTrim.abbreviatedName = orgUnitGeneralInfoFormTrim.abbreviatedName
        ? orgUnitGeneralInfoFormTrim.abbreviatedName.trim()
        : '';
      orgUnitGeneralInfoFormTrim.privacyPolicyUrl = orgUnitGeneralInfoFormTrim.privacyPolicyUrl
        ? orgUnitGeneralInfoFormTrim.privacyPolicyUrl.trim()
        : '';
      orgUnitGeneralInfoFormTrim.troubleshootingUrl = orgUnitGeneralInfoFormTrim.troubleshootingUrl
        ? orgUnitGeneralInfoFormTrim.troubleshootingUrl.trim()
        : '';
      orgUnitGeneralInfoFormTrim.termsAndConditionUrl = orgUnitGeneralInfoFormTrim.termsAndConditionUrl
        ? orgUnitGeneralInfoFormTrim.termsAndConditionUrl.trim()
        : '';
      orgUnitGeneralInfoFormTrim.callerEntryPage = orgUnitGeneralInfoFormTrim.callerEntryPage
        ? orgUnitGeneralInfoFormTrim.callerEntryPage.trim()
        : '';

      orgUnitGeneralInfoFormTrim.featuresEnabled = orgUnitGeneralInfoFormTrim.featuresEnabled;

      return objectAssign({}, state, { updatedOrgUnitGeneralInfoForm: orgUnitGeneralInfoFormTrim });
    case CLEAR_ORG_UNIT_GENERAL_INFO_FORM: {
      return objectAssign({}, state, {
        updatedOrgUnitGeneralInfoForm: {
          name: '',
          abbreviatedName: '',
          orgNameDuplicate: false,
        },
      });
    }
    // Org Unit Support Contact
    case ORG_UNIT_SUPPORT_CONTACT.GOT_ORG_UNIT_SUPPORT_CONTACT_INFO:
      var organisations = clone(state.organisations);
      var orgUnitSupportContactForm = {
        organisaionSupportName: action.data.organisaionSupportName || '',
        organisaionSupportEmail: action.data.organisaionSupportEmail || '',
        organisaionSupportPhone:
          action.data.organisaionSupportPhone == 'Not provided' ? '' : action.data.organisaionSupportPhone || '',
        organisaionSupportWebsite:
          action.data.organisaionSupportWebsite == 'Not provided' ? '' : action.data.organisaionSupportWebsite || '',
        moreAssistance: action.data.moreAssistance || '',
      };

      if (organisations.length > 0)
        var foundOrganisation = organisations.find((x) => x.networkId == state.selectedOrgUnit.networkId);
      if (foundOrganisation) foundOrganisation.orgUnitSupportContactForm = orgUnitSupportContactForm;
      return objectAssign({}, state, {
        organisations: organisations,
        updatedOrgUnitSupportContactForm: orgUnitSupportContactForm,
      });
    case ORG_UNIT_SUPPORT_CONTACT.CHANGE_ORG_UNIT_SUPPORT_CONTACT_INFO:
      return objectAssign({}, state, { updatedOrgUnitSupportContactForm: action.data });

    // Before calls (Important Info)
    case GOT_ORGANISATIONAL_UNIT_BEFORE_CALLS_FOR_WA: {
      let beforeCallsFormForWA = {
        importantInfo: {
          value: action.data.htmlContent,
          maxLineLength: action.data.maxLineLength || 10,
          maxCharLength: action.data.maxCharLength || 500,
          ifTextEmpty: false,
          showCharLimitWarning: false,
        },
      };
      return objectAssign({}, state, {
        beforeCallsFormForWA: beforeCallsFormForWA,
      });
    }

    case MODIFIED_ORGANISATIONAL_UNIT_BEFORE_CALLS_FOR_WA:
      var beforeCallsFormForWA = clone(state.beforeCallsFormForWA);
      beforeCallsFormForWA.importantInfo.value = action.data.value;
      beforeCallsFormForWA.importantInfo.ifTextEmpty = action.data.ifTextEmpty;
      beforeCallsFormForWA.importantInfo.showCharLimitWarning = action.data.showCharLimitWarning || false;
      return objectAssign({}, state, {
        beforeCallsFormForWA: beforeCallsFormForWA,
      });

    // Entity admin
    case GOT_ALL_ENTITIES_PAGINATION: {
      let currentEntities = clone(state.organisations);
      let receivedOrgUnits = clone(action.data.organisationalUnits);
      let filteredEntities = action.data.pageNo == 1 ? [] : currentEntities;
      // When action.data.pageNo == 1, it means start a new search;
      // Has to reset currentActivePageNo to be 0 for new search; not reset to 1 because it will be incremented by another dispatch later
      let currentActivePageNo = action.data.pageNo == 1 ? 0 : state.entitySearchForm.currentActivePageNo;
      // Set WA related properties for each OU
      if (receivedOrgUnits && action.data.searchedEntityType === 'org') {
        receivedOrgUnits.forEach((orgUnit) => {
          orgUnit.waCurrentActivePageNo = 1;
          orgUnit.mrCurrentActivePageNo = 1;
          orgUnit.fetchingWaitingAreas = false;
          orgUnit.fetchingMeetingRooms = false;
          orgUnit.waitingAreas = orgUnit.waitingAreas || [];
          orgUnit.meetingRooms = orgUnit.meetingRooms || [];
          orgUnit.waitingAreasTotalCount = 1;
          orgUnit.meetingRoomsTotalCount = 1;
        });
      }

      if (
        filteredEntities.length > 0 &&
        receivedOrgUnits.length > 0 &&
        filteredEntities[filteredEntities.length - 1].networkId === receivedOrgUnits[0].networkId
      ) {
        let waitingAreasOfEdgedOrg = [
          ...filteredEntities[filteredEntities.length - 1].waitingAreas,
          ...receivedOrgUnits[0].waitingAreas,
        ];
        // If an org's MR has not completely fetched from last page, it will continue on fetching the rest on this page
        // We need to group the loaded MRs and the new fetched MRs within 1 org instead of 2 orgs with same name
        let meetingRoomsOfEdgedOrg = [
          ...filteredEntities[filteredEntities.length - 1].meetingRooms,
          ...receivedOrgUnits[0].meetingRooms,
        ];
        let edgedOrg = {
          ...receivedOrgUnits[0],
          waitingAreas: waitingAreasOfEdgedOrg,
          meetingRooms: meetingRoomsOfEdgedOrg,
        };
        // new page data's first org unit is the continueing with last page's last org unit
        filteredEntities[filteredEntities.length - 1] = edgedOrg;
        receivedOrgUnits.shift();
      }

      let organisationsNew = [...filteredEntities, ...receivedOrgUnits];
      organisationsNew = removeDuplicateArray(organisationsNew, 'id');
      var sortedOrgUnits = sortOrganisationalUnit(organisationsNew);
      let totalRows = parseInt(action.data.totalRows, 10);
      let filteredRows = parseInt(action.data.filteredRows, 10);
      let newEntitySearchForm =
        // If fetch mrs list, then needs to update total number of mrs
        state.entitySearchForm.searchString == ''
          ? {
              ...state.entitySearchForm,
              totalRowsForSet: totalRows || 0,
              numberOfEntities: totalRows || 0,
              currentActivePageNo: currentActivePageNo,
              searchedEntityType: action.data.searchedEntityType,
            }
          : {
              ...state.entitySearchForm,
              totalRowsForSet: filteredRows || totalRows,
              numberOfEntities: totalRows,
              currentActivePageNo: currentActivePageNo,
              searchedEntityType: action.data.searchedEntityType,
            };

      let newEntityStats =
        state.entitySearchForm.searchString == '' && action.data.searchedEntityType === 'org'
          ? {
              matchedOUs: action.data.totalRows,
              wasOfMatchedOUs: action.data.totalWaitingAreas,
              mrsOfMatchedOUs: action.data.totalMeetingRooms,
              totalOURows: action.data.totalRows,
              totalWAs: action.data.totalWaitingAreas,
              totalMRs: action.data.totalMeetingRooms,
            }
          : {
              ...state.entityStats,
              matchedOUs: action.data.totalRows,
              wasOfMatchedOUs:
                typeof action.data.totalWaitingAreas === 'number'
                  ? action.data.totalWaitingAreas
                  : action.data.totalRows,
              mrsOfMatchedOUs:
                typeof action.data.totalMeetingRooms === 'number'
                  ? action.data.totalMeetingRooms
                  : action.data.totalRows,
            };
      return objectAssign({}, state, {
        organisations: sortedOrgUnits,
        entitySearchForm: newEntitySearchForm,
        entityStats: newEntityStats,
      });
    }

    case RESET_ENTITY_SEARCH_FROM: {
      let entitySearchForm = clone(state.entitySearchForm);
      let currentNumberOfEntities = entitySearchForm.numberOfEntities || 0;
      // If current mr filter is not empty, use filter string as search string
      let searchString =
        typeof state.currentOrgUnitFilter == 'string' && state.currentOrgUnitFilter.trim() != ''
          ? state.currentOrgUnitFilter
          : '';

      let resetEntitySearchForm = {
        ...organisationInitialState.entitySearchForm,
        numberOfEntities: currentNumberOfEntities,
        searchString: searchString,
      };

      return objectAssign({}, state, {
        organisations: organisationInitialState.organisations,
        entitySearchForm: resetEntitySearchForm,
      });
    }

    case UPDATE_ENTITY_SEARCH_FROM: {
      let entitySearchForm = clone(state.entitySearchForm);
      let newEntitySearchForm = {
        ...entitySearchForm,
        ...action.data,
      };
      return objectAssign({}, state, { entitySearchForm: newEntitySearchForm });
    }

    case UPDATE_CURRENT_ACTIVE_PAGENO_FOR_ENTITY_PAGE: {
      let entitySearchForm = clone(state.entitySearchForm);

      let newEntitySearchForm = {
        ...entitySearchForm,
        currentActivePageNo: parseInt(entitySearchForm.currentActivePageNo, 10) + parseInt(action.data, 10),
      };
      return Object.assign({}, state, {
        entitySearchForm: newEntitySearchForm,
      });
    }

    case IS_ON_ENTITY_LISTING_PAGE: {
      return Object.assign({}, state, {
        isOnEntityListingPage: action.data,
      });
    }

    // Entity admin - Fetching paged WAs
    case GOT_ALL_WA_ENTITIES_PAGINATION: {
      let organisations = clone(state.organisations);
      if (organisations.length <= 0) {
        return state;
      }

      var organisation = organisations.find((x) => x.networkId == action.data.orgUnitNetworkId);
      if (!organisation) {
        return state;
      }

      let filteredEntities = action.data.pageNo == 1 ? [] : organisation.waitingAreas;
      let waitingAreasNew = [...filteredEntities, ...action.data.waitingAreas];
      waitingAreasNew = removeDuplicateArray(waitingAreasNew, 'id');

      let totalRows = parseInt(action.data.totalRows, 10);
      organisation.waCurrentActivePageNo = action.data.pageNo + 1;
      organisation.fetchingWaitingAreas = false;
      organisation.waitingAreas = waitingAreasNew;
      organisation.waitingAreasTotalCount = totalRows;

      return objectAssign({}, state, {
        organisations: organisations,
      });
    }

    case IS_FETCHING_WA_ENTITIES: {
      let organisations = clone(state.organisations);
      if (organisations.length <= 0) {
        return state;
      }

      var organisation = organisations.find((x) => x.networkId == action.data.orgUnitNetworkId);
      if (!organisation) {
        return state;
      }

      organisation.fetchingWaitingAreas = action.data.fetchingWaitingAreas;

      return Object.assign({}, state, {
        organisations: organisations,
      });
    }
    // Get WA data by Id & search term
    case GOT_WAITING_AREA_BY_SEARCH_TERM: {
      let organisations = clone(state.organisations);
      let foundIndex = organisations.findIndex((x) => x.networkId == action.data.orgNetworkId);
      if (foundIndex > -1) {
        // Found the existing org unit
        let parentOrg = {
          ...organisations[foundIndex],
        };
        let waFoundIndex = parentOrg.waitingAreas.findIndex((x) => x.id == action.data.id);

        if (!!action.data.isInSearchCriteria) {
          if (waFoundIndex > -1) {
            // replace current wa
            parentOrg.waitingAreas[waFoundIndex] = {
              ...parentOrg.waitingAreas[waFoundIndex],
              ...action.data,
            };
          } else {
            parentOrg.waitingAreas.push(action.data);
          }
        } else {
          // remove this wa from the list & org unit count minus 1
          if (waFoundIndex > -1) {
            parentOrg.waitingAreas.splice(waFoundIndex, 1);
          }
        }
        organisations[foundIndex] = { ...parentOrg };
      }

      return Object.assign({}, state, {
        organisations: organisations,
      });
    }

    case DELETED_WAITING_AREA_FROM_ORG: {
      let organisations = clone(state.organisations);
      let newEntityStats = clone(state.entityStats);
      let foundIndex = organisations.findIndex((x) => x.networkId == action.data.networkId);
      if (foundIndex > -1) {
        // Found the existing org unit
        let parentOrg = {
          ...organisations[foundIndex],
        };
        let waFoundIndex = parentOrg.waitingAreas.findIndex((x) => x.id == action.data.waitingAreaId);
        if (waFoundIndex > -1) {
          // remove from current list
          parentOrg.waitingAreas.splice(waFoundIndex, 1);
          newEntityStats.wasOfMatchedOUs = newEntityStats.wasOfMatchedOUs - 1;
          newEntityStats.totalWAs = newEntityStats.totalWAs - 1;
        }
      }

      return Object.assign({}, state, {
        organisations: organisations,
        entityStats: newEntityStats,
      });
    }

    // Entity admin - Fetching paged MRs
    case GOT_ALL_MR_ENTITIES_PAGINATION: {
      let organisations = clone(state.organisations);
      if (organisations.length <= 0) {
        return state;
      }

      var organisation = organisations.find((x) => x.networkId == action.data.orgUnitNetworkId);
      if (!organisation) {
        return state;
      }

      let filteredEntities = action.data.pageNo == 1 ? [] : organisation.meetingRooms;
      let meetingRoomsNew = [...filteredEntities, ...action.data.meetingRooms];
      meetingRoomsNew = removeDuplicateArray(meetingRoomsNew, 'id');

      let totalRows = parseInt(action.data.totalRows, 10);
      organisation.mrCurrentActivePageNo = action.data.pageNo + 1;
      organisation.fetchingMeetingRooms = false;
      organisation.meetingRooms = meetingRoomsNew;
      organisation.meetingRoomsTotalCount = totalRows;

      return objectAssign({}, state, {
        organisations: organisations,
      });
    }

    // Get MR data by Id & search term
    case GOT_MEETING_ROOM_BY_ID_AND_SEARCH_TERM: {
      let organisations = clone(state.organisations);
      let foundIndex = organisations.findIndex((x) => x.networkId == action.data.organisationNetworkId);
      if (foundIndex > -1) {
        // Found the existing org unit
        let parentOrg = {
          ...organisations[foundIndex],
        };
        let mrFoundIndex = parentOrg.meetingRooms.findIndex((x) => x.id == action.data.id);

        if (!!action.data.isInSearchCriteria) {
          if (mrFoundIndex > -1) {
            // replace current wa
            parentOrg.meetingRooms[mrFoundIndex] = {
              ...parentOrg.meetingRooms[mrFoundIndex],
              ...action.data,
            };
          } else {
            parentOrg.meetingRooms.push(action.data);
          }
        } else {
          // remove this wa from the list & org unit count minus 1
          if (mrFoundIndex > -1) {
            parentOrg.meetingRooms.splice(mrFoundIndex, 1);
          }
        }
        organisations[foundIndex] = { ...parentOrg };
      }

      return Object.assign({}, state, {
        organisations: organisations,
      });
    }

    case DELETED_MEETING_ROOM_FROM_ORG: {
      let organisations = clone(state.organisations);
      let newEntityStats = clone(state.entityStats);
      let foundIndex = organisations.findIndex((x) => x.networkId == action.data.networkId);
      if (foundIndex > -1) {
        // Found the existing org unit
        let parentOrg = {
          ...organisations[foundIndex],
        };
        let mrFoundIndex = parentOrg.meetingRooms.findIndex((x) => x.id == action.data.meetingRoomId);
        if (mrFoundIndex > -1) {
          // remove from current list
          parentOrg.meetingRooms.splice(mrFoundIndex, 1);
          newEntityStats.mrsOfMatchedOUs = newEntityStats.mrsOfMatchedOUs - 1;
          newEntityStats.totalMRs = newEntityStats.totalMRs - 1;
        }
      }

      return Object.assign({}, state, {
        organisations: organisations,
        entityStats: newEntityStats,
      });
    }

    case UPDATE_RHS_TOTAL_COUNT: {
      let newEntityStats = clone(state.entityStats);
      if (action.data.entityType === 'org') {
        newEntityStats.totalOURows = newEntityStats.totalOURows + action.data.offset;
      } else if (action.data.entityType === 'wa') {
        newEntityStats.totalWAs = newEntityStats.totalWAs + action.data.offset;
      } else if (action.data.entityType === 'mr') {
        newEntityStats.totalMRs = newEntityStats.totalMRs + action.data.offset;
      }
      return Object.assign({}, state, {
        entityStats: newEntityStats,
      });
    }
    // Retain filter value from Manage Users/Tags
    case UPDATE_FILTER_VALUE: {
      return Object.assign({}, state, {
        storedFilterValue: action.data,
      });
    }

    // Org Unit Share Link Message for WA
    case GOT_SHARE_LINK_MESSAGE_FOR_WA: {
      let organisations = clone(state.organisations);
      var foundIndex = organisations.findIndex((selectedOrg) => selectedOrg.networkId == action.data.id);
      if (foundIndex > -1) {
        organisations[foundIndex].orgUnitShareLinkForWAForm = action.data;
      }
      return objectAssign({}, state, {
        organisations: organisations,
        orgUnitShareLinkForWAForm: action.data,
      });
    }
    case GOT_OURECORDING_SETTING_FEATURE: {
      return objectAssign({}, state, { OURecordingFeature: action.data });
    }

    case REMOVE_DELETED_ORGANIZATION: {
      let organisations = clone(state.organisations);
      let newEntityStats = clone(state.entityStats);
      newEntityStats.matchedOUs = newEntityStats.matchedOUs - 1;
      newEntityStats.totalOURows = newEntityStats.totalOURows - 1;
      newEntityStats.wasOfMatchedOUs = newEntityStats.wasOfMatchedOUs - action.data.waitingAreaCount;
      newEntityStats.totalWAs = newEntityStats.totalWAs - action.data.waitingAreaCount;
      newEntityStats.mrsOfMatchedOUs = newEntityStats.mrsOfMatchedOUs - action.data.meetingRoomCount;
      newEntityStats.totalMRs = newEntityStats.totalMRs - action.data.meetingRoomCount;
      let filteredOrganizations = organisations.filter((organisation) => organisation.id !== action.data.id);
      return objectAssign({}, state, {
        organisations: filteredOrganizations,
        entityStats: newEntityStats,
      });
    }

    case SET_MEETING_ROOMS_DELETION_STATUS: {
      return objectAssign({}, state, {
        meetingRoomsDeletionStatus: action.data,
      });
    }

    case SET_WAITING_AREAS_DELETION_STATUS: {
      return objectAssign({}, state, {
        waitingAreasDeletionStatus: action.data,
      });
    }

    case SET_ORGANIZATION_DELETION_STATUS: {
      return objectAssign({}, state, {
        organizationDeletionStatus: action.data,
      });
    }
    default:
      return state;
  }
};

export default reducer;
